(function () {
        'use strict';

        angular
            .module('observationEditRoutes', [
                'controlModule',
                'observationEditModule'
            ])
            .config(router);

        router.$inject = ['$stateProvider', 'historyCtxtServiceProvider'];

        function router($stateProvider, historyCtxtServiceProvider) {
            $stateProvider
                .state('observation', {
                    abstract: true,
                    url: '/Observation',
                    data: {
                        breadcrumb: {
                            getBreadcrumb: function (resolves) {

                                // Audit Mandate
                                if (resolves.observation.GovernanceProcess) {
                                    return {
                                        cssIcon: 'fa fa-road',
                                        title: resolves.observation.GovernanceProcess.ShortNameAndFiscalYear,
                                        stateName: 'auditMandateEdit',
                                        stateParams: {
                                            AuditMandateID: resolves.auditMandate.AuditMandateID
                                        }
                                    }
                                }

                                if (resolves.observation.ObservationContainer) {                                    
                                    let stateName = null;

                                    if(resolves.observation.RecomBusinessUnit.Code == "InformationSecurityMandate"){
                                        stateName = "newInformationSecurityMandateSearch";
                                    } else if (resolves.observation.RecomBusinessUnit.Code == "AssessmentRecommendation"){
                                        stateName = "newInformationSecurityProviderSearch";
                                    } else if(resolves.observation.RecomBusinessUnit.Code == "DerogationException"){
                                        stateName = "newGovernanceDerogationSearch";
                                    } else if (resolves.observation.RecomBusinessUnit.Code == "BTGMandate") {
                                        stateName = "newGovernanceMandateSearch";
                                    }
                                                                         
                                    return {
                                        cssIcon: 'fa fa-road',
                                        title: resolves.observation.ObservationContainer.TitleEN,
                                        stateParams: {
                                            facets: 'ObservationContainerIdForSearch=' + 
                                                                    resolves.observation
                                                                    .ObservationContainer
                                                                    .ObservationContainerID
                                        },                                    
                                        stateName: stateName
                                    }
                                }

                                // Control Test
                                if (resolves.controlTest && resolves.controlTest.ControlTestID) {
                                    return {
                                        cssIcon: 'fa fa-pencil-square-o',
                                        title: 'Control Test',
                                        stateName: 'control.controlTests.edit',
                                        stateParams: {
                                            ControlID: resolves.controlTest.ControlID,
                                            ControlTestID: resolves.controlTest.ControlTestID
                                        }
                                    }
                                }

                                // ODD Campaign
                                if (resolves.observation.ODDCampaignID) {
                                    return {
                                        cssIcon: 'fa fa-bullhorn',
                                        title: resolves.oddCampaign.TitleEN,
                                        stateName: 'odd.externalPartyEdit.campaign',
                                        stateParams: {
                                            CampaignTypeCode: resolves.businessUnit.CampaignType.Value.toLowerCase(),
                                            BusinessUnitCode: resolves.oddCampaign.ODDBusinessUnitCode,
                                            ODDExternalPartyID: resolves.oddCampaign.ODDExternalPartyID,
                                            ODDCampaignID: resolves.oddCampaign.ODDCampaignID
                                        }
                                    }
                                }
                            }
                        }
                    },
                    resolve: {
                        // Default Resolves
                        oddCampaign: function () {
                            return undefined;
                        },
                        businessUnit: function () {
                            return undefined;
                        },
                        controls: function () {
                            return undefined;
                        },
                        controlTest: function () {
                            return undefined;
                        }
                    },
                    views: {
                        '': {
                            template: '<div ui-view="breadcrumbs" class="breadcrumbs-container"></div><div ui-view="mainContent"></div>'
                        },
                        'breadcrumbs@observation': {
                            templateUrl: require('./observationBreadcrumbs.tpl.html')
                        }
                    }
                })

                // Observation Add
                .state('observation.add', {
                    url: '/Add/ForControlTest/{ControlTestID:int}',
                    params: historyCtxtServiceProvider.getStateParamsConfig(),
                    data: {
                        breadcrumb: null // to prevent double breadcrumb elements
                    },
                    resolve: {
                        observation: ['$stateParams', function ($stateParams) {
                            return {
                                ControlTestID: $stateParams.ControlTestID
                            };
                        }],
                        controlTest: ['grcControlService', 'observation', function (service, observation) {
                            return service.getControlTest(observation.ControlTestID);
                        }]
                    },
                    views: {
                        'mainContent@observation': {
                            templateUrl: require('./observationEdit.tpl.html'),
                            controller: 'ObservationEditController'
                        }
                    }
                })

                // Observation Add For Audit Mandate
                .state('observation.addForAuditMandate', {
                    url: '/Add/ForAuditMandate/{AuditMandateID:int}',
                    params: historyCtxtServiceProvider.getStateParamsConfig(),
                    data: {
                        breadcrumb: null // to prevent double breadcrumb elements
                    },
                    resolve: {
                        observation: ['$stateParams', 'grcGovernanceProcessService', function ($stateParams, service) {
                            return service
                                .getAuditMandateProcesses()
                                .then(function (auditMandates) {
                                    return {
                                        GovernanceProcess: _.find(auditMandates, {GovernanceProcessID: $stateParams.AuditMandateID}),
                                        GovernanceProcessID: $stateParams.AuditMandateID
                                    };
                                });

                        }],
                        auditMandate: ['auditMandateService', 'observation', function (service, observation) {
                            if (_.isUndefined(observation.GovernanceProcessID)) return undefined;

                            return service.getAuditMandateByGovernanceProcessID(observation.GovernanceProcessID);
                        }]
                    },
                    views: {
                        'mainContent@observation': {
                            templateUrl: require('./observationEdit.tpl.html'),
                            controller: 'ObservationEditController'
                        }
                    }
                })

                // Observation Add For ODD Campaign
                .state('observation.addForODDCampaign', {
                    url: '/Add/ForCampaign/{BusinessUnitCode:string}/{ODDCampaignID:int}',
                    params: historyCtxtServiceProvider.getStateParamsConfig(),
                    data: {
                        breadcrumb: null // to prevent double breadcrumb elements
                    },
                    resolve: {
                        businessUnit: ['$stateParams', 'oddService', function ($stateParams, service) {
                            return service.getBusinessUnit($stateParams.BusinessUnitCode);
                        }],
                        oddCampaign: ['$stateParams', 'oddCampaignService', 'businessUnit', function ($stateParams, service, businessUnit) {
                            return service.getCampaign(businessUnit.ODDBusinessUnitID, $stateParams.ODDCampaignID);
                        }],
                        observation: ['$stateParams', function ($stateParams) {
                            return {
                                ODDCampaignID: $stateParams.ODDCampaignID
                            }
                        }]
                    },
                    views: {
                        'mainContent@observation': {
                            templateUrl: require('./observationEdit.tpl.html'),
                            controller: 'ObservationEditController'
                        }
                    }
                })

                // Observation Edit
                .state('observation.edit', {
                    url: '/{ObservationID:int}',
                    params: historyCtxtServiceProvider.getStateParamsConfig(),
                    data: {
                        breadcrumb: [
                            // {
                            //     title: 'Observations',
                            //     cssIcon: 'fa fa-search',
                            //     usingHistoryCtxt: true,
                            //     defaultCtxtState: 'newRecomSearch'
                            // },
                            // {
                            //     title: 'Recommendations',
                            //     cssIcon: 'fa fa-search',
                            //     usingHistoryCtxt: true,
                            //     defaultCtxtState: 'newRecomSearch'
                            // }
                        ]
                        // breadcrumb: {
                        //     title: 'Observation',
                        //     cssIcon: 'fa fa-area-chart'
                        // }
                    },
                    resolve: {
                        observation: ['$stateParams', 'grcObservationService', function ($stateParams, service) {
                            return service.getObservation($stateParams.ObservationID);
                        }],
                        controls: ['$stateParams', 'grcObservationService', 'observation', function ($stateParams, service, observation) {
                            if (_.isUndefined(observation)) return null;
                            if (!observation.HasObservationControl_View) return null;
                            return service.getRelatedControls($stateParams.ObservationID);
                        }],
                        controlTest: ['grcControlService', 'observation', function (service, observation) {
                            if (_.isUndefined(observation.TestResult)) return;

                            var controlTestId = observation.TestResult.ControlTestID;

                            return service.getControlTest(controlTestId);
                        }],
                        oddCampaign: ['oddCampaignService', 'observation', function (service, observation) {
                            return observation.ODDCampaign;
                        }],
                        businessUnit: ['oddService', 'oddCampaign', function (oddService, oddCampaign) {
                            if (_.isUndefined(oddCampaign)) return undefined;

                            return oddService.getBusinessUnit(oddCampaign.ODDBusinessUnitCode);
                        }],
                        auditMandate: ['auditMandateService', 'observation', function (service, observation) {
                            if (_.isUndefined(observation.GovernanceProcessID)) return undefined;

                            return service.getAuditMandateByGovernanceProcessID(observation.GovernanceProcessID);
                        }]
                    },
                    views: {
                        'mainContent@observation': {
                            templateUrl: require('./observationEdit.tpl.html'),
                            controller: 'ObservationEditController'
                        }
                    }
                })

                // Observation - Add Recommendation
                .state('observation.edit.recommendationAdd', {
                    url: '/Recommendation/Add',
                    data: {
                        // Must be specified as otherwise reads from inherited parent breadcrumb
                        breadcrumb: null
                    },
                    views: {
                        'mainContent@observation': {
                            templateUrl: require('./observationRecommendationAdd.tpl.html'),
                            controller: 'ObservationRecommendationAddController',
                            resolve: {
                                observation: [function () {
                                    return [];
                                }]
                            }
                        }
                    }
                })
                
                .state('observation.edit.parentview', {
                    //url: '/AuditMandate/{AuditMandateID:int}',
                    //params: historyCtxtServiceProvider.getStateParamsConfig(),                     
                    //templateUrl: require('./AuditMandateEdit.tpl.html'),
                    //controller: 'AuditMandateEditController',
                });

            // History Context
            historyCtxtServiceProvider.setCtxtState('observation.edit',
                '/app/Main/grcEdit/observation/GOVHistoryCtxtDirective-observation.tpl.html'
            );
        }
    }
)();